import React from 'react';
import { Card } from 'react-bootstrap';
import SubliSnapProduct from '../img/subli-snap-right.png';
import BoxBottle from '../img/box-bottle.png';

// Flip this when sales reopen
const SOLD_OUT = false;

const gtag_report_conversion = (url) => {
  const callback = () => {
    window.location.href = url;
  };

  window.gtag('event', 'conversion', {
    send_to: 'AW-11112049019/F4mFCKmbhsMZEPvS0bIp',
    event_callback: callback,
  });

  return false;
};

const ProductCards = () => {
  const handleBuyNowClick = (e, url) => {
    e.preventDefault();

    if (SOLD_OUT) {
      return;
    }

    gtag_report_conversion(url);
  };

  const buyBtnStyles = SOLD_OUT
    ? { pointerEvents: 'none', opacity: 0.6, cursor: 'not-allowed' }
    : undefined;

  return (
    <section className="card-container product-card-mt-large eql-font">
      <Card style={{ borderBottom: 'none' }}>
        <img
          className="blue-bg product-card-img"
          alt="step one - Sublimation spray"
          src={SubliSnapProduct}
          loading="lazy"
        />
        <span className="product-card-txt">SUBLISNAP SPRAY</span>

        <div className="btn-call-to-action-container">
          <a
            className="call-to-btn"
            href="https://sublisnap.com/product-page/sublimation-spray"
          >
            VIEW PRODUCT
          </a>

          {SOLD_OUT ? (
            <span
              className="call-to-btn"
              aria-label="sold out"
              aria-disabled="true"
              style={buyBtnStyles}
            >
              <span>SOLD OUT</span>
            </span>
          ) : (
            <a
              href="https://buy.stripe.com/7sI8zB5CjaXF5JmdQT"
              className="call-to-btn"
              aria-label="a button to purchase product"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) =>
                handleBuyNowClick(e, 'https://buy.stripe.com/7sI8zB5CjaXF5JmdQT')
              }
            >
              <span>BUY NOW</span>
            </a>
          )}
        </div>
      </Card>

      <Card style={{ borderBottom: 'none' }}>
        <img
          className="orange-bg product-card-img"
          alt="step two - Sublimation spray"
          src={BoxBottle}
          loading="lazy"
        />
        <span className="product-card-txt">SUBLISNAP CARDBOARD COATING</span>

        <div className="btn-call-to-action-container">
          <a className="call-to-btn" href="https://custom-shipping-boxes.com/">
            LEARN MORE
          </a>

          {SOLD_OUT ? (
            <span
              className="call-to-btn"
              aria-label="sold out"
              aria-disabled="true"
              style={buyBtnStyles}
            >
              <span>SOLD OUT</span>
            </span>
          ) : (
            <a
              href="https://buy.stripe.com/5kAeXZ7KrfdV4Fi5kl"
              className="call-to-btn"
              aria-label="a button to purchase product"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) =>
                handleBuyNowClick(e, 'https://buy.stripe.com/5kAeXZ7KrfdV4Fi5kl')
              }
            >
              <span>BUY NOW</span>
            </a>
          )}
        </div>
      </Card>
    </section>
  );
};

export default ProductCards;
